import React from "react"
import { Input, Label, FormFeedback } from "reactstrap"
import { Controller } from "react-hook-form"

const QwikInput = ({
  type,
  name,
  label,
  placeholder,
  control,
  className,
  required = false, // ✅ default value set here
  rules = {}, // optional validation rules
}) => {
  // Merge default rules with required conditionally
  const finalRules = {
    ...rules,
    ...(required ? { required: `${label || name} is required` } : {}),
  }

  return (
    <Controller
      name={name}
      control={control}
      rules={finalRules}
      render={({ field, fieldState: { error } }) => (
        <>
          {label && (
            <Label className="form-label" for={name}>
              {label} {required && <span className="text-danger">*</span>}
            </Label>
          )}
          <Input
            {...field}
            value={field.value ?? ""}
            type={type}
            id={name}
            placeholder={placeholder}
            invalid={!!error}
            className={className}
          />
          {error && <FormFeedback>{error.message}</FormFeedback>}
        </>
      )}
    />
  )
}

export default QwikInput
